import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Approach } from './pages/Approach';
import { Portfolio } from './pages/Portfolio';
import { Founders } from './pages/Founders';
import { Team } from './pages/Team';
import { Values } from './pages/Values';
import { Updates } from './pages/Updates';
import { Contact } from './pages/Contact';
// Scroll to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen bg-deepCanopy text-white font-sans selection:bg-vitalityTeal selection:text-deepCanopy" data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <Navigation data-id="element-3" />
        <main className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
            <Route path="/approach" element={<Approach data-id="element-9" />} data-id="element-8" />
            <Route path="/portfolio" element={<Portfolio data-id="element-11" />} data-id="element-10" />
            <Route path="/founders" element={<Founders data-id="element-13" />} data-id="element-12" />
            <Route path="/team" element={<Team data-id="element-15" />} data-id="element-14" />
            <Route path="/values" element={<Values data-id="element-17" />} data-id="element-16" />
            <Route path="/updates" element={<Updates data-id="element-19" />} data-id="element-18" />
            <Route path="/contact" element={<Contact data-id="element-21" />} data-id="element-20" />
          </Routes>
        </main>
        <Footer data-id="element-22" />
      </div>
    </Router>;
}